import { useContext } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Tooltip, IconButton, Zoom, Chip, FormControlLabel, Checkbox } from '@mui/material';
import { MdInfo as InfoIcon, MdCheck as CheckIcon, MdCheck } from 'react-icons/md';
import { ticketDetailsContext } from '../../TicketDetailsContext';
import { DeleteIconButton, SimecUser } from 'components';
import { appUserContext } from 'helpers/services';
import { LocalizationIds } from 'helpers/Localizations';
import { useIntl } from 'react-intl';


const DesktopVersion = () => {
    const { formatMessage } = useIntl();

    const { currentUser } = useContext(appUserContext);
    const service = useContext(ticketDetailsContext);


    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>{formatMessage({ id: LocalizationIds.Name })}</TableCell>
                    <TableCell align="center"></TableCell>
                    <TableCell align="right"></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {service.ticket.assigneeUserName && service.ticket.assigneeUserName !== '' &&
                    <TableRow>
                        <TableCell>{service.ticket.assigneeUser}</TableCell>
                        <TableCell align='center'>
                            <Chip icon={<MdCheck />} label={formatMessage({ id: LocalizationIds.ReceiveNotifications })} />
                        </TableCell>
                        <TableCell align="right">
                            <Tooltip TransitionComponent={Zoom} title={formatMessage({ id: LocalizationIds.Assignee })}>
                                <IconButton size="small" color="secondary">
                                    <InfoIcon />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    </TableRow>
                }
                {service.ticket.reporterUserName && service.ticket.reporterUserName !== '' &&
                    <TableRow>
                        <TableCell>{service.ticket.reporterUser}</TableCell>
                        <TableCell align='center'>
                            <Chip icon={<MdCheck />} label={formatMessage({ id: LocalizationIds.ReceiveNotifications })} />
                        </TableCell>
                        <TableCell align="right">
                            <Tooltip TransitionComponent={Zoom} title={formatMessage({ id: LocalizationIds.Reporter })}>
                                <IconButton size="small" color="secondary">
                                    <InfoIcon />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    </TableRow>
                }
                {service.ticketWatchers
                    .map((watcher, index) =>
                        <TableRow key={index}>
                            <TableCell>
                                <SimecUser username={watcher.email} />
                            </TableCell>
                            <TableCell align='center'>
                                {watcher.canUpdateNotificationsFlag === false && watcher.receiveNotifications === true &&
                                    <Chip icon={<MdCheck />} label={formatMessage({ id: LocalizationIds.ReceiveNotifications })} />
                                }
                                {watcher.canUpdateNotificationsFlag &&
                                    <FormControlLabel
                                        label={formatMessage({ id: LocalizationIds.ReceiveNotifications })}
                                        control={<Checkbox
                                            checked={watcher.receiveNotifications}
                                            onChange={async (e) => await service.updateWatcher({ ...watcher, receiveNotifications: e.target.checked })}
                                            color="secondary"
                                        />}
                                    />
                                }
                            </TableCell>
                            <TableCell align="right">
                                {service.ticket.isReadOnly === false && currentUser.simecClaims.canWorkOnMyTickets === false &&
                                    <DeleteIconButton onClick={async () => await service.removeWatcher(watcher.email)} />
                                }
                            </TableCell>
                        </TableRow>
                    )}
            </TableBody>
        </Table>
    )
}

export default DesktopVersion;